<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <ReportListing />
    </Layout>
</template>
<script>
import Layout from '@/views/layouts/main';
import PageHeader from '@/components/page-header';
import i18n from '@/i18n';
import ReportListing from '@/views/pages/admin/report/reportListing';

export default {
    page: {
        title: i18n.t('module.report'),
    },
    components: { Layout, PageHeader, ReportListing },
    data() {
        return {
            title: i18n.t('module.report'),
            items: [
                {
                    text: i18n.t('module.communication'),
                    href: '/communications',
                },
                {
                    text: i18n.t('module.report'),
                    active: true,
                },
            ],
        };
    },
};
</script>
